import { useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";

/**
 * Manuell pflegbare Google-Reviews-Sektion.
 * - Trage deine Rezensionen im REVIEWS-Array ein.
 * - Jede Rezension zeigt Sterne, Text, Autor, Datum + Link zur Google-Quelle.
 * - "Mehr anzeigen" klappt lange Texte auf.
 */

const REVIEWS = [
    {
        author: "Michael Teplitzky",
        rating: 5,
        date: "Februar 2025",
        text:
            "Top Falle Wenn man sich an die Tipps Ort, Köder usw. des Herstellers hält, erzielt man mit Einbau der Falle sofort beachtliche Fangerfolge - Innerhalb von 2 Monaten konnte ich 10 Kreaturen fangen.Ich kann Tuscher´s Betonrohrfallen nur weiterempfehlen und werde bei mir im Revier zusätzliche Fallen installieren.",
        sourceUrl: "https://g.page/r/CcB_B2dngBtxEBM/review", // <- optional, Link zur Original-Bewertung
    },
    {
        author: "hei ka",
        rating: 5,
        date: "August 2025",
        text:
            "Ein super Fallen Konzept und sehr effektiv, zudem gute Beratung und netter Kontakt",
        sourceUrl: "https://g.page/r/CcB_B2dngBtxEBM/review",
    },
    {
        author: "Dietrich Christian Freiherr von Horst (Didi)",
        rating: 5,
        date: "Februar 2025",
        text:
            "Tolle Beratung, tolle Produkte, sehr empfehlenswert",
        sourceUrl: "https://g.page/r/CcB_B2dngBtxEBM/review",
    },
    {
        author: "Annika R",
        rating: 5,
        date: "Juli 2022",
        text:
            "1A Qualität und die Funktionalität zeigt, dass sehr viel Erfahrung drinsteckt! Tolle Beratung ist inklusive und ich war bereits sehr viele Male erfolgreich mit Tuschers Betonrohrfalle. Klare Empfehlung 👍🏼",
        sourceUrl: "https://g.page/r/CcB_B2dngBtxEBM/review",
    },
    {
        author: "Stefan Abg",
        rating: 5,
        date: "März 2023",
        text:
            "Zuverlässiger, kompetenter Partner in Sachen Fallenjagd. Bei Fragen steht’s professionell und behilflich.",
        sourceUrl: "https://g.page/r/CcB_B2dngBtxEBM/review",
    },
];

function Stars({ value = 5 }) {
    const v = Math.max(0, Math.min(5, Number(value) || 0));
    return (
        <div className="flex items-center gap-0.5" aria-label={`${v} von 5 Sternen`}>
            {Array.from({ length: 5 }).map((_, i) => (
                <Star
                    key={i}
                    className={`h-4 w-4 ${i < v ? "fill-yellow-400 stroke-yellow-400" : "stroke-slate-300 dark:stroke-slate-600"}`}
                />
            ))}
        </div>
    );
}

function ReviewCard({ r }) {
    const [open, setOpen] = useState(false);
    const maxChars = 160;
    const needsClamp = (r.text || "").length > maxChars;
    const shown = open || !needsClamp ? r.text : r.text.slice(0, maxChars) + "…";

    return (
        <article className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 h-full flex flex-col">
            <div className="flex items-center justify-between gap-3">
                <Stars value={r.rating} />
                <span className="text-xs text-slate-500">{r.date}</span>
            </div>
            <p className="mt-3 text-sm text-slate-700 dark:text-slate-300">{shown}</p>

            {needsClamp && (
                <button
                    onClick={() => setOpen((o) => !o)}
                    className="mt-2 self-start text-sm font-medium text-brand hover:underline"
                >
                    {open ? "Weniger anzeigen" : "Mehr anzeigen"}
                </button>
            )}

            <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
                <span>Quelle: Google Rezensionen</span>
                {r.sourceUrl ? (
                    <a
                        href={r.sourceUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-brand hover:underline"
                        aria-label="Originalbewertung auf Google öffnen"
                    >
                        Auf Google öffnen →
                    </a>
                ) : null}
            </div>
        </article>
    );
}

export default function GoogleReviewsSection({
    title = "Kundenstimmen",
    subtitle = "Echte Erfahrungen aus der Praxis.",
    ctaTo = "https://g.page/r/CcB_B2dngBtxEBM/review",
}) {
    return (
        <section className="mx-auto max-w-6xl px-4 py-12">
            <div className="text-center max-w-2xl mx-auto">
                <p className="text-sm font-semibold text-brand uppercase tracking-wide">Bewertungen</p>
                <h2 className="mt-2 text-3xl md:text-4xl font-heading font-extrabold">{title}</h2>
                <p className="mt-2 text-slate-600 dark:text-slate-300">{subtitle}</p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {REVIEWS.map((r, i) => (
                    <ReviewCard key={i} r={r} />
                ))}
            </div>

            <div className="mt-6 text-center">
                <Link to={ctaTo} target="_blank"
                    rel="noopener noreferrer" className="inline-block rounded-md border border-brand text-brand px-5 py-3 font-medium hover:bg-brand/10" > Eigene Erfahrung teilen → </Link>
            </div>
        </section>
    );
}
